import { assertNotNullish, } from '@synapex/tools/typescript';
function getWdFromSnake(snakeIdObj) {
    if (typeof snakeIdObj.site_link_id === 'number' &&
        typeof snakeIdObj.site_id === 'number') {
        return {
            workspace_type: 'site',
            workspace_id: snakeIdObj.site_id,
            link_id: snakeIdObj.site_link_id,
        };
    }
    else if (typeof snakeIdObj.invite_link_id === 'number' &&
        typeof snakeIdObj.channel_id === 'number') {
        return {
            workspace_type: 'channel',
            workspace_id: snakeIdObj.channel_id,
            link_id: snakeIdObj.invite_link_id,
        };
    }
    return null;
}
function getWdFromSnakeOrThrow(snakeIdObj) {
    const r = getWdFromSnake(snakeIdObj);
    assertNotNullish(r, `getWdFromSnakeOrThrow: ${JSON.stringify(snakeIdObj)}`);
    return r;
}
function getWdFromCamel(camelIdObj) {
    if (typeof camelIdObj.siteId === 'number' &&
        typeof camelIdObj.siteLinkId === 'number') {
        return {
            workspace_type: 'site',
            workspace_id: camelIdObj.siteId,
            link_id: camelIdObj.siteLinkId,
        };
    }
    else if (typeof camelIdObj.channelId === 'number' &&
        typeof camelIdObj.inviteLinkId === 'number') {
        return {
            workspace_type: 'channel',
            workspace_id: camelIdObj.channelId,
            link_id: camelIdObj.inviteLinkId,
        };
    }
    return null;
}
function getWdFromCamelOrThrow(camelIdObj) {
    const r = getWdFromCamel(camelIdObj);
    assertNotNullish(r, `getWdFromCamelOrThrow: ${JSON.stringify(camelIdObj)}`);
    return r;
}
function getCamelFromWd(wd) {
    if (wd.workspace_type === 'site') {
        return {
            siteId: wd.workspace_id,
            siteLinkId: wd.link_id,
        };
    }
    else {
        return {
            channelId: wd.workspace_id,
            inviteLinkId: wd.link_id,
        };
    }
}
function getSnakeFromWd(wd) {
    if (wd.workspace_type === 'site') {
        return {
            site_id: wd.workspace_id,
            site_link_id: wd.link_id,
        };
    }
    else {
        return {
            channel_id: wd.workspace_id,
            invite_link_id: wd.link_id,
        };
    }
}
function split({ workspace_type, workspace_id, link_id, }) {
    return {
        workspaceDescriptor: {
            workspace_type,
            workspace_id,
        },
        linkDescriptor: {
            workspace_type,
            link_id,
        },
    };
}
function pickWwld({ workspace_type, workspace_id, link_id, }) {
    return {
        workspace_type,
        workspace_id,
        link_id,
    };
}
function getWwld(ws) {
    if (ws.workspace_type === 'site') {
        return {
            workspace_type: 'site',
            workspace_id: ws.site_id,
            link_id: ws.site_link_id,
        };
    }
    else {
        return {
            workspace_type: 'channel',
            workspace_id: ws.channel_id,
            link_id: ws.invite_link_id,
        };
    }
}
function extractWwld({ link_id, workspace_id, workspace_type, ...rest }) {
    return [
        {
            link_id,
            workspace_id,
            workspace_type,
        },
        rest,
    ];
}
export const workspaceWithLinkMethods = {
    getWdFromSnake,
    getWdFromSnakeOrThrow,
    getWdFromCamel,
    getWdFromCamelOrThrow,
    getCamelFromWd,
    getSnakeFromWd,
    split,
    pickWwld,
    getWwld,
    extractWwld,
};
//# sourceMappingURL=workspaceWithLink.js.map